import { useEffect, useState } from 'react';
import config from '../../common/config';

import './styles/Digest3.less';

const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  const slide = config.slides[seq];

  useEffect(() => {
    if (play) {
      setTimeout(() => {
        setDelayPlay(true);
      }, 300);
    } else {
      setDelayPlay(false);
    }
  }, [play]);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <div className="digest">
        <div className={`logo-q`}>
          <img src={(slide.images as Array<string>)[0]} alt="logo quality" />
        </div>

        <div className={`text-block ${delayPlay ? 'ani-fade-in' : ''}`}>
          <div className={`titles`}>
            <div className="title title-primary">设计品质</div>
            <div className="title title-secondary">Brand DNA</div>
          </div>
          <div className="description">
            <div>延续麦当劳品牌设计图形DNA，融入UI设计：</div>
            <div>薯条、芝士、芝麻粒都是Design System中的Aurum</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Digest;
